import { useTranslation } from "react-i18next";
import { ActionIcon, Flex, Paper, Text, Tooltip } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { Tenant } from "src/graphql/generated/graphql";

import { UpdateTenantNameModal } from "../../../../../../modals/UpdateTenantName";
export interface InfoWidgetProps {
    tenant: Tenant;
    onTenantUpdate?();
}

export const InfoWidget = ({ tenant, onTenantUpdate }: InfoWidgetProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <Paper pos="relative" p={36} radius={12}>
            <Flex h="36px" justify="space-between">
                <Text weight={500}>{t("tenant_name")}</Text>
                <Tooltip label={t("tenant_name_update")} withArrow>
                    <ActionIcon
                        variant="subtle"
                        color="orange"
                        onClick={() =>
                            UpdateTenantNameModal.display({
                                tenantId: tenant?.id,
                                onSave: onTenantUpdate,
                            })
                        }
                    >
                        <IconEdit size="1em" />
                    </ActionIcon>
                </Tooltip>
            </Flex>
            <Text>{tenant?.name || "-"}</Text>
        </Paper>
    );
};
